import { HandleErrorsGlobalRecord, RefreshWindow, ShowErrorNotification } from '@platform-frontend/util';
import {
  MSG_PLATFORM_DEFAULT,
  MSG_PLATFORM_MAX_REQUESTS_EXCEEDED,
  MSG_PLATFORM_NOT_FOUND,
  MSG_PLATFORM_NO_ACCESS,
  MSG_PLATFORM_SERVER_UNREACHABLE
} from './notification-messages';

export const PLATFORM_ERROR_HANDLERS: HandleErrorsGlobalRecord = {
  SERVER_UNREACHABLE: new ShowErrorNotification(MSG_PLATFORM_SERVER_UNREACHABLE),
  MAX_REQUESTS_EXCEEDED: new ShowErrorNotification(MSG_PLATFORM_MAX_REQUESTS_EXCEEDED),
  NO_ACCESS: new ShowErrorNotification(MSG_PLATFORM_NO_ACCESS),
  NOT_FOUND: new RefreshWindow(MSG_PLATFORM_NOT_FOUND),
  DEFAULT: new ShowErrorNotification(MSG_PLATFORM_DEFAULT)
};
